import React from "react";
import "./RefundCancellation.css";

const policies = [
  {
    title: "Refund Eligibility",
    description:
      "Refunds are available within 7 days of purchase if the service has not been used. Requests beyond this period may not be entertained."
  },
  {
    title: "Cancellation Policy",
    description:
      "Subscriptions can be cancelled anytime. Cancellation will take effect from the next billing cycle. No partial refunds for the current cycle."
  },
  {
    title: "Processing Time",
    description:
      "Refunds will be processed within 5-7 business days after approval. Refunds will be credited to the original payment method."
  },
  {
    title: "Non-Refundable Cases",
    description:
      "Late fees, one-time setup charges, and services already availed are non-refundable."
  }
];

const RefundCancellation = () => {
  return (
    <div className="refund-page">
      {/* Header */}
      <div className="refund-header">
        <h1>REFUND & CANCELLATION POLICY</h1>
        <p>Read our refund and cancellation rules carefully.</p>
      </div>

      {/* Policy Cards */}
      <div className="refund-cards">
        {policies.map((policy, index) => (
          <div key={index} className="refund-card">
            <h3>{policy.title}</h3>
            <p>{policy.description}</p>
          </div>
        ))}
      </div>

      {/* Footer Note */}
      <div className="refund-footer">
        <p>
          For further assistance, contact our support team at{" "}
          <strong>support@company.com</strong>.
        </p>
      </div>
    </div>
  );
};

export default RefundCancellation;
